<template>
  <div class="o-progress-bar">
    <label :id="labelId">{{ label }}</label>
    <div role="progressbar" class="o-progress-bar-inner" :aria-labelledby="labelId" :style="{ width: `${progress}%` }" :aria-valuenow="progress" />
  </div>
</template>
<script>
export default {
  name: 'o-progress-bar',
  props: {
    progress: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      default: 'Progress'
    }
  },
  data() {
    return {
      labelId: `o-progress-bar-label-${Math.floor(Math.random() * 16)}` // Generate a random unique ID.
    }
  }
}
</script>
<style lang="scss" scoped>
.o-progress-bar {
  background-color: var(--color-progress-secondary);
  width: 100%;
  min-height: 4px;
  position: relative;

  label {
    position: absolute;
    left: -99999px;
  }

  &-inner {
    background-color: var(--color-progress-primary);
    bottom: 0;
    left: 0;
    position: absolute;
    top: 0;
    transition: all 500ms ease-in-out;
  }
}
</style>
